<template>
    <div
        class="fixed inset-x-0 bottom-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center z-50"
    >
        <div class="fixed inset-0 transition-opacity">
            <div
                @click="confirmResult(false)"
                class="absolute inset-0 bg-gray-500 opacity-75"
            ></div>
        </div>

        <div
            class="px-4 pt-5 pb-4 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:max-w-lg sm:w-full sm:p-6"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
        >
            <slot></slot>
            <div class="flex items-center justify-center mt-5">
                <span
                    class="flex w-full rounded-md gap-10 shadow-sm sm:col-start-2"
                >
                    <button
                        type="button"
                        @click="confirmResult(true)"
                        class="inline-flex justify-center w-1/2 px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-red-500 border border-transparent rounded-md shadow-sm hover:bg-red-600 focus:outline-none focus:border-red-600 focus:shadow-outline-red sm:text-sm sm:leading-5"
                    >
                        Oui
                    </button>
                    <button
                        type="button"
                        @click="confirmResult(false)"
                        class="inline-flex justify-center w-1/2 px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-800 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue sm:text-sm sm:leading-5"
                    >
                        Non
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        confirmResult(result) {
            this.$emit("confirmationResult", result);
        }
    }
};
</script>

<style></style>
